// extracted by mini-css-extract-plugin
module.exports = {"AboutPage":"AboutPage_AboutPage__kqZDV","AboutPageHeader":"AboutPage_AboutPageHeader__xQlWb","AboutPageSubHeader":"AboutPage_AboutPageSubHeader__3xkBZ"};